import styled from 'styled-components'
import { XButton } from '../../components/Button'
import useMyBlindBox, { BlindBox } from '../../hooks/useMyBlindBox'
import Loading from '../../components/common/Loading'
import useOpenBlindBox from '../../hooks/useOpenBlindBox'
import useMyOpenedBlindBox from '../../hooks/useMyOpenedBlindBox'
import { Link } from 'react-router-dom'
import { STATICS } from '../../static'

import useEnvConfig from 'hooks/useEnvConfig'
import { shortenAddress } from '../../utils'

export default function Blindbox() {
  const { blindBoxes, loading } = useMyBlindBox()
  const { blindBoxes: opendBlindBoxed } = useMyOpenedBlindBox()
  return (
    <BlindBoxWrapper>
      <Title>
        Mystery box unopened{' '}
        {blindBoxes.length > 4 && (
          <ViewMore to={'/viewmore/unopened'} replace>
            See more <ViewMoreIcon />{' '}
          </ViewMore>
        )}
      </Title>

      {loading ? (
        <LoadingWrapper>
          <Loading height={100} />
        </LoadingWrapper>
      ) : (
        <BlindBoxListWrapper>
          {blindBoxes.slice(0, 4).map((box) => (
            <BlindCard key={box.id} blindBox={box} />
          ))}
        </BlindBoxListWrapper>
      )}

      <Title style={{ marginTop: 46 }}>
        Mystery box opened
        {opendBlindBoxed.length > 4 && (
          <ViewMore to={'/viewmore/opened'} replace>
            See more <ViewMoreIcon />{' '}
          </ViewMore>
        )}
      </Title>
      <BlindBoxListWrapper>
        {opendBlindBoxed.slice(0, 4).map((nft) => (
          <BlindCard blindBox={nft} opened key={nft.id} />
        ))}
      </BlindBoxListWrapper>
    </BlindBoxWrapper>
  )
}

const LoadingWrapper = styled.div`
  position: relative;
  height: 365px;
  padding-top: 50px;
`

const BlindBoxWrapper = styled.div`
  width: 100%;
  position: relative;
  margin-top: 36px;
`
const Title = styled.h3`
  font-size: 24px;
  color: #fff;
  line-height: 29px;
  position: relative;
`

const BlindBoxListWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 273px);
  grid-column-gap: 20px;
  grid-row-gap: 20px;
  margin-top: 26px;
  min-height: 365px;
`

export function BlindCard(props: { opened?: boolean; blindBox: BlindBox }) {
  const envConfig = useEnvConfig()
  const { claim } = useOpenBlindBox()
  const address = props.opened ? envConfig.ADDRESS_OPENED_NFT : envConfig.ADDRESS_COCOS_BLINDBOXNFT
  return (
    <BlindCardWrapper>
      {props.opened ? (
        <Link replace to={`/mysterybox-info?token_id=${props.blindBox.id}&contract=${address}`}>
          <NftImageWrapper>
            <NFTImage src={props.blindBox.image || STATICS.FantasyBox} />
          </NftImageWrapper>
        </Link>
      ) : (
        <NftImageWrapper>
          <NFTImage src={props.blindBox.image || STATICS.FantasyBox} />
        </NftImageWrapper>
      )}
      <NFTName>
        {props.blindBox.name} #{props.blindBox.id}
      </NFTName>
      {props.opened ? (
        <OpenedText>{shortenAddress(address, 5)}</OpenedText>
      ) : (
        <OpenButton
          onClick={async () => {
            await claim(props.blindBox.id)
          }}
        >
          Open
        </OpenButton>
      )}
    </BlindCardWrapper>
  )
}

const BlindCardWrapper = styled.div`
  width: 273px;
  height: 390px;
  border-radius: 8px;
  padding: 14px;
  border: 2px solid #376cdf;
  background: linear-gradient(136deg, #11388c 0%, #01246e 100%);
`

const NftImageWrapper = styled.div`
  width: 244px;
  height: 244px;
  border-radius: 7px;
  overflow: hidden;
`
const NFTImage = styled.img`
  width: 244px;
  height: 244px;
  transition: transform 0.2s linear;

  &:hover {
    transform: scale(1.2);
  }
`
const NFTName = styled.p`
  line-height: 20px;
  font-size: 14px;
  color: #fff;
  text-align: center;
  margin-top: 14px;
`

const OpenButton = styled(XButton)`
  width: 166px;
  height: 38px;
  display: block;
  margin: 14px auto 0 auto;
`

const OpenedText = styled.p`
  line-height: 18px;
  color: #6090f8;
  text-align: center;
  font-size: 13px;
  margin-top: 14px;
`

const ViewMore = styled(Link)`
  width: 200px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  position: absolute;
  right: 0;
  top: 0;
  font-size: 16px;
  color: #74a0ff;
  outline: none;
  text-decoration: none;
`

const ViewMoreIcon = styled.span`
  display: inline-block;
  width: 18px;
  height: 18px;
  background-repeat: no-repeat;
  background-size: contain;
  transition: all 0.2s linear;
  margin-left: 10px;
  background-image: url(${STATICS.MoreIcon});

  ${ViewMore}:hover & {
    background-image: url(${STATICS.MoreHoverIcon});
  }
`
